export default {
  hotel: {
    default: 'Hôtel | Hôtels',
    negotiated: {
      title: 'Hôtels à tarifs préférentiels'
    },
    others: {
      title: 'Autres hôtels'
    },
    list: {
      page_title: 'Liste des hôtels'
    },
    show: {
      page_title: 'Fiche hôtel'
    },
    equipments: {
      hotelConfiguration: 'Configuration de l\'hôtel',
      roomConfiguration: 'Equipements des chambres',
      service: 'Services de l\'hotel'
    },
    infos: {
      reception: 'Réception',
      receptionWE: 'Réception le week-end',
      from: 'Arrivée à partir de',
      to: 'Départ avant',
      freeServices: 'Services gratuits',
      time: {
        from: 'de',
        to: 'à'
      }
    },
    hotel_infos: 'Informations hôtelières',
    filter: {
      placeholder: 'Filtrer les services',
      carpark: 'Parking',
      restaurant: 'Restaurant',
      internet: 'Internet',
      breakfast: 'Petit-déjeuner',
      disabled: 'Accès PMR'
    },
    order: {
      placeholder: 'Trier par catégorie'
    },
    booking: "Réservation Hôtel"
  }
}
